import React from "react"
import { ElementToolbar as BaseElementToolbar } from "@convertkit/editor"
import { ButtonMenu } from "./plugins/button-menu"
import { ImageMenu } from "./plugins/image-menu"
import { ProductMenu } from "./plugins/products/product-menu"
import { SpotifyMenu } from "./plugins/spotify-menu"
import { VideoMenu } from "./plugins/video-menu"
import { VideoEmbedMenu } from "./plugins/video-embed-menu"
import { TimerMenu } from "./plugins/countdown-timer/timer-menu"

const renderNodeForElementToolbar = (editor, node) => {
  if (!editor || !node) return null
  const type = node && node.type
  switch (type) {
    case "button":
      return <ButtonMenu editor={editor} node={node} />
    case "timer":
      return <TimerMenu editor={editor} node={node} />
    case "image":
      return <ImageMenu editor={editor} node={node} />
    case "product":
      return <ProductMenu editor={editor} node={node} />
    case "video":
      return <VideoMenu editor={editor} node={node} />
    case "video-embed":
      return <VideoEmbedMenu editor={editor} node={node} />
    case "spotify":
      return <SpotifyMenu editor={editor} node={node} />
  }
}

export function ElementToolbar() {
  return <BaseElementToolbar renderNode={renderNodeForElementToolbar} />
}
